export default __webpack_public_path__ + "static/media/sence-2.be5a96b7.png";